import React from 'react';

const EmptyDataIcon = (props) => (
  <svg width='320' height='225' viewBox='0 0 240 166' {...props}>
    <g fill='none'>
      <circle fill='#FF6584' cx='45.5' cy='22.5' r='13.5' />
      <path
        d='M112 73.41C112 105.72 92.748 117 69 117s-43-11.281-43-43.59C26 41.102 69 0 69 0s43 41.102 43 73.41z'
        fill='#F2F2F2'
      />
      <path
        fill='#3F3D56'
        d='m67.258 111.7.44-26.953L86 51.402 67.767 80.52l.198-12.12 12.613-24.124-12.561 20.918.356-21.797L81.88 24.189 68.429 39.97 68.65 0l-1.397 52.91.115-2.182-13.732-20.934 13.512 25.124-1.28 24.343-.038-.646L50 56.585l15.783 24.313-.16 3.044-.028.046.013.25L62.362 146h4.337l.52-31.901 15.745-24.253z'
      />
      <path
        d='M240 86.234c0 26.51-15.67 35.766-35 35.766s-35-9.256-35-35.766C170 59.724 205 26 205 26s35 33.724 35 60.234z'
        fill='#F2F2F2'
      />
      <path
        fill='#3F3D56'
        d='m202.903 117.809.354-22.153L218 68.249 203.312 92.18l.16-9.96 10.16-19.83-10.118 17.193.286-17.915 10.88-15.786-10.835 12.969.18-32.851-1.126 43.488.093-1.794-11.063-17.206 10.886 20.65-1.031 20.009-.031-.532L189 72.51l12.714 19.983-.129 2.502-.023.038.011.205L198.958 146h3.494l.419-26.22 12.683-19.934z'
      />
      <ellipse fill='#3F3D56' cx='118' cy='145' rx='118' ry='6' />
      <ellipse fill='#3F3D56' cx='190' cy='155' rx='20' ry='1' />
      <ellipse fill='#3F3D56' cx='117' cy='165' rx='20' ry='1' />
      <ellipse fill='#3F3D56' cx='62' cy='156' rx='46' ry='2' />
      <circle fill='#2F2E41' cx='20.5' cy='121.5' r='16.5' />
      <path
        fill='#2F2E41'
        d='m12.93 133.975 5.121.06-.108 9.176-5.12-.06zM23.172 134.096l5.121.06-.108 9.176-5.12-.06z'
      />
      <ellipse fill='#2F2E41' transform='rotate(-89.325 17.089 143.308)' cx='17.089' cy='143.308' rx='1.6' ry='4.268' />
      <ellipse fill='#2F2E41' transform='rotate(-89.325 27.333 143.215)' cx='27.333' cy='143.215' rx='1.6' ry='4.268' />
      <circle fill='#FFF' cx='21' cy='116' r='6' />
      <circle fill='#3F3D56' cx='21' cy='117' r='2' />
      <path
        d='M5.224 105.43c-1.295-6.326 3.15-12.648 9.93-14.121 6.781-1.473 13.328 2.461 14.624 8.787 1.296 6.326-3.213 8.599-9.993 10.072-6.78 1.473-13.265 1.588-14.56-4.738z'
        fill='#633FFF'
      />
      <path
        d='M46 129.98C46 141.854 39.06 146 30.5 146a26.188 26.188 0 0 1-1.772-.061C21.002 145.382 15 141.023 15 129.979c0-11.428 14.357-25.848 15.436-26.916l.002-.002.062-.061S46 118.106 46 129.98z'
        fill='#633FFF'
      />
      <path
        d='m30.232 144.19 5.671-8.059-5.685 8.944-.015.925c-.397-.009-.79-.028-1.178-.055l.611-11.882-.005-.092.01-.017.058-1.122L24 123.866l5.717 8.124.014.238.461-8.977-4.879-9.265 4.939 7.69.48-18.613.003-.063v.061l-.08 14.677 4.857-5.818-4.877 7.083-.129 8.037 4.536-7.714-4.555 8.897-.072 4.468L37 121.955l-6.61 12.296-.158 9.939z'
        fill='#3F3D56'
      />
      <circle fill='#2F2E41' cx='151.5' cy='120.5' r='16.5' />
      <path
        fill='#2F2E41'
        d='m148.632 135.558 4.896-1.505 2.695 8.771-4.895 1.505zM158.423 132.55l4.895-1.505 2.696 8.771-4.896 1.505z'
      />
      <ellipse
        fill='#2F2E41'
        transform='rotate(-17.083 155.439 143.177)'
        cx='155.439'
        cy='143.177'
        rx='4.268'
        ry='1.6'
      />
      <ellipse
        fill='#2F2E41'
        transform='rotate(-17.083 165.167 139.964)'
        cx='165.167'
        cy='139.964'
        rx='4.268'
        ry='1.6'
      />
      <circle fill='#FFF' cx='151' cy='116' r='6' />
      <circle fill='#3F3D56' cx='152' cy='117' r='2' />
      <path
        d='M132.352 110.687c-3.068-5.396-.737-12.521 5.207-15.914 5.945-3.393 13.25-1.77 16.319 3.626 3.068 5.396-.507 8.835-6.45 12.229-5.945 3.393-12.008 5.455-15.076.059zM122 128.47c0 10.77-6.492 14.53-14.5 14.53a25.273 25.273 0 0 1-1.657-.056C98.615 142.44 93 138.486 93 128.47c0-10.365 13.431-23.445 14.44-24.412l.002-.002.058-.056s14.5 13.7 14.5 24.47z'
        fill='#633FFF'
      />
      <path
        d='m106.753 141.358 5.235-7.309-5.248 8.112-.014.839a23.379 23.379 0 0 1-1.088-.05l.565-10.776-.005-.084.01-.016.053-1.017-5.261-8.132 5.278 7.368.012.216.426-8.142-4.504-8.403 4.56 6.974.443-16.88.002-.058v.056l-.074 13.311 4.484-5.277-4.503 6.424-.118 7.29 4.186-6.996-4.204 8.069-.066 4.052 6.078-9.737-6.1 11.152-.147 9.014z'
        fill='#3F3D56'
      />
      <path
        d='M178 132.98c0 11.874-6.94 16.02-15.5 16.02a26.188 26.188 0 0 1-1.772-.061c-7.726-.557-13.728-4.916-13.728-15.96 0-11.428 14.357-25.848 15.436-26.916l.002-.002.062-.061s15.5 15.106 15.5 26.98z'
        fill='#633FFF'
      />
      <path
        d='m162.232 147.19 5.671-8.059-5.685 8.944-.015.925c-.397-.009-.79-.028-1.178-.055l.611-11.882-.005-.092.01-.017.058-1.122-5.699-8.966 5.717 8.124.014.238.462-8.977-4.88-9.265 4.939 7.69.48-18.613.003-.063v.061l-.08 14.677 4.857-5.818-4.877 7.083-.129 8.037 4.536-7.714-4.555 8.897-.072 4.468L169 124.955l-6.61 12.296-.158 9.939z'
        fill='#3F3D56'
      />
      <ellipse
        fill='#2F2E41'
        transform='rotate(-64.626 145.544 127.134)'
        cx='145.544'
        cy='127.134'
        rx='2.646'
        ry='8.429'
      />
      <ellipse
        fill='#2F2E41'
        transform='rotate(-68.158 15.589 126.067)'
        cx='15.589'
        cy='126.067'
        rx='2.646'
        ry='8.429'
      />
    </g>
  </svg>
);

export default EmptyDataIcon;
